<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-lg">
          <div class="page-links">
            <router-link
              to="/safari/calculation"
              class="page-links__item is-active"
              >Calculation Setting</router-link
            >
            <router-link to="/safari/parks" class="page-links__item"
              >National Parks</router-link
            >
          </div>
          <div class="lds-ring" v-if="!isLoad">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section class="calculation-settings" v-if="isLoad">
            <div class="page-title">
              <h2>Safari | Calculation Setting</h2>
            </div>
            <div class="calculation-settings__inner">
              <div class="calculation-settings__rental">
                <div class="section-title">
                  <h3>Safari car - Rental</h3>
                  <a
                    href="javascript:void(0)"
                    class="btn btn--green"
                    @click="isOpenSeasonsCar = true">
                    <svg width="1em" height="1em" class="icon icon-list">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-list"></use></svg
                    ><span>Seasons</span></a
                  >
                </div>
                <form
                  action="javascript:void(0)"
                  class="calculation-settings__box"
                  v-if="carSeasons.find((item) => item.active)">
                  <div class="calculation-settings__box__header">
                    <div class="form-control-group">
                      <span class="form-control-label">Choose Season</span>
                      <div
                        :class="[
                          'select-wrapper',
                          'select-wrapper--xl',
                          {'is-active': selects.car},
                        ]"
                        @click="
                          changeSelects('car')
                          carsData = carsData.map((otherItem, i) => ({
                            ...otherItem,
                            select: false,
                          }))
                          otherData = otherData.map((item) => ({
                            ...item,
                            select: false,
                          }))
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name"
                            ><b>{{
                              carSeasons.find((item) => item.active).name
                            }}</b>
                            <i
                              >{{
                                dateConvert(
                                  carSeasons.find((item) => item.active)
                                    .dateFrom,
                                  's'
                                )
                              }}
                              -
                              {{
                                dateConvert(
                                  carSeasons.find((item) => item.active).dateTo,
                                  's'
                                )
                              }}</i
                            ></span
                          ><span class="select-trigger__icon">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner">
                            <div
                              v-for="item in carSeasons"
                              :key="item.id"
                              :class="[
                                'select-option',
                                {'is-selected': item.active},
                              ]"
                              @click="
                                carSeasons = carSeasons.map((season) =>
                                  season.id === item.id
                                    ? {...season, active: true}
                                    : {...season, active: false}
                                )
                              ">
                              <span class="select-option__name"
                                ><b>{{ item.name }}</b>
                                <i
                                  >{{ dateConvert(item.dateFrom, 's') }} -
                                  {{ dateConvert(item.dateTo, 's') }}</i
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <span title="Sorry, this season is not available because something is wrong" class="form-control-group__error">Sorry, this season is not available because something is wrong</span> -->
                    </div>
                    <button
                      type="button"
                      data-popover="Copy rates from another season"
                      @click="copyCar = true"
                      class="btn btn--green btn--sm-squared btn--popover">
                      <svg width="1em" height="1em" class="icon icon-copy">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="calculation-settings__box__inner">
                    <div class="season-box__table-wrap js-scrollbar">
                      <div class="season-box__table">
                        <div class="season-box__table__header">
                          <div class="season-box__table__main">
                            <span>Days Safari</span>
                          </div>
                          <div class="season-box__table__currency">
                            <span>Currency</span>
                          </div>
                          <div class="season-box__table__price">
                            <span>Price</span>
                          </div>
                        </div>
                        <div
                          class="season-box__table__row"
                          v-for="(item, index) in carsData"
                          :key="item.id">
                          <div class="season-box__table__main">
                            <input
                              type="text"
                              placeholder="Days"
                              v-model="item.name"
                              @input="
                                item.name = $event.target.value.replace(
                                  /[^0-9+ ]/g,
                                  ''
                                )
                                isEdit = true
                              "
                              @focus="
                                $event.target.parentElement.classList.remove(
                                  'is-error'
                                )
                              "
                              class="form-control form-control-calc-name" />
                          </div>
                          <div class="season-box__table__currency">
                            <div
                              :class="[
                                'select-wrapper',
                                'select-wrapper--xs',
                                {'is-active': item.select},
                              ]"
                              @click="
                                carsData = carsData.map((otherItem, i) => ({
                                  ...otherItem,
                                  select:
                                    i === index ? !otherItem.select : false,
                                }))
                                otherData = otherData.map((item) => ({
                                  ...item,
                                  select: false,
                                }))
                                changeSelects()
                              ">
                              <div class="select-trigger">
                                <span class="select-trigger__name">{{
                                  item.currencyType
                                }}</span
                                ><span class="select-trigger__icon">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                    <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                              </div>
                              <div class="select-body">
                                <div class="select-inner">
                                  <div
                                    :class="[
                                      'select-option',
                                      {
                                        'is-selected':
                                          item.currencyType === 'USD',
                                      },
                                    ]"
                                    @click="
                                      item.currencyType = 'USD'
                                      isEdit = true
                                    ">
                                    <span class="select-option__name">USD</span>
                                  </div>
                                  <div
                                    :class="[
                                      'select-option',
                                      {
                                        'is-selected':
                                          item.currencyType === 'TZS',
                                      },
                                    ]"
                                    @click="
                                      item.currencyType = 'TZS'
                                      isEdit = true
                                    ">
                                    <span class="select-option__name">TZS</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="season-box__table__price">
                            <input
                              type="number"
                              placeholder="Price"
                              @input="isEdit = true"
                              v-model="item.price"
                              @focus="
                                $event.target.parentElement.classList.remove(
                                  'is-error'
                                )
                              "
                              class="form-control form-control-calc-price" />
                          </div>
                          <div class="season-box__table__action">
                            <button
                              type="button"
                              class="btn btn--remove"
                              @click="
                                $emit('deleteModalHandler', {
                                  entity: 'Setting',
                                  name: 'this',
                                  handler: removeRental,
                                  id: index,
                                })
                              ">
                              <svg
                                width="1em"
                                height="1em"
                                class="icon icon-close">
                                <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="calculation-settings__box__submit">
                      <!-- <button type="button" class="btn btn--rounded" @click="addRental"><span>Add</span></button> -->
                      <button
                        type="button"
                        class="btn btn--green btn--sm btn--save"
                        @click="saveRental">
                        <span>Save</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="calculation-settings__other">
                <div class="section-title">
                  <h3>Other expenses</h3>
                  <a
                    href="javascript:void(0)"
                    @click="isOpenSeasonsOther = true"
                    class="btn btn--green">
                    <svg width="1em" height="1em" class="icon icon-list">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-list"></use></svg
                    ><span>Seasons</span></a
                  >
                </div>
                <form
                  action="javascript:void(0)"
                  class="calculation-settings__box"
                  v-if="otherSeasons.find((item) => item.active)">
                  <div class="calculation-settings__box__header">
                    <div class="form-control-group">
                      <span class="form-control-label">Choose Season</span>
                      <div
                        :class="[
                          'select-wrapper',
                          'select-wrapper--xl',
                          {'is-active': selects.other},
                        ]"
                        @click="
                          changeSelects('other')
                          carsData = carsData.map((otherItem, i) => ({
                            ...otherItem,
                            select: false,
                          }))
                          otherData = otherData.map((item) => ({
                            ...item,
                            select: false,
                          }))
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name"
                            ><b>{{
                              otherSeasons.find((item) => item.active).name
                            }}</b>
                            <i
                              >{{
                                otherSeasons.find((item) => item.active)
                                  .dateFrom
                              }}
                              -
                              {{
                                otherSeasons.find((item) => item.active).dateTo
                              }}</i
                            ></span
                          ><span class="select-trigger__icon">
                            <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                              <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                          ></span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner">
                            <div
                              v-for="item in otherSeasons"
                              :key="item.id"
                              :class="[
                                'select-option',
                                {'is-selected': item.active},
                              ]"
                              @click="
                                otherSeasons = otherSeasons.map((season) =>
                                  season.id === item.id
                                    ? {...season, active: true}
                                    : {...season, active: false}
                                )
                              ">
                              <span class="select-option__name"
                                ><b>{{ item.name }}</b>
                                <i
                                  >{{ item.dateFrom }} - {{ item.dateTo }}</i
                                ></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      data-popover="Copy rates from another season"
                      @click="copyOther = true"
                      class="btn btn--green btn--sm-squared btn--popover">
                      <svg width="1em" height="1em" class="icon icon-copy">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                      </svg>
                    </button>
                  </div>
                  <div class="calculation-settings__box__inner">
                    <div class="season-box__table-wrap js-scrollbar">
                      <div class="season-box__table">
                        <div class="season-box__table__header">
                          <div class="season-box__table__main">
                            <span>Name</span>
                          </div>
                          <div class="season-box__table__currency">
                            <span>Currency</span>
                          </div>
                          <div class="season-box__table__price">
                            <span>Price</span>
                          </div>
                        </div>
                        <div
                          class="season-box__table__row"
                          v-for="(item, index) in otherData"
                          :key="index">
                          <div :class="['season-box__table__main']">
                            <input
                              type="text"
                              placeholder="Name"
                              v-model="item.name"
                              @focus="
                                $event.target.parentElement.classList.remove(
                                  'is-error'
                                )
                              "
                              @input="
                                item.name = $event.target.value.replace(
                                  /[^A-Za-z0-9- ]/g,
                                  ''
                                )
                                isEdit = true
                              "
                              class="form-control form-control-other-name" />
                          </div>
                          <div class="season-box__table__currency">
                            <div
                              :class="[
                                'select-wrapper',
                                'select-wrapper--xs',
                                {'is-active': item.select},
                              ]"
                              @click="
                                otherData = otherData.map((otherItem, i) => ({
                                  ...otherItem,
                                  select:
                                    i === index ? !otherItem.select : false,
                                }))
                                carsData = carsData.map((item) => ({
                                  ...item,
                                  select: false,
                                }))
                                changeSelects()
                              ">
                              <div class="select-trigger">
                                <span class="select-trigger__name">{{
                                  item.currencyType
                                }}</span
                                ><span class="select-trigger__icon">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-chevron">
                                    <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                                ></span>
                              </div>
                              <div class="select-body">
                                <div class="select-inner">
                                  <div
                                    :class="[
                                      'select-option',
                                      {
                                        'is-selected':
                                          item.currencyType === 'USD',
                                      },
                                    ]"
                                    @click="
                                      item.currencyType = 'USD'
                                      isEdit = true
                                    ">
                                    <span class="select-option__name">USD</span>
                                  </div>
                                  <div
                                    :class="[
                                      'select-option',
                                      {
                                        'is-selected':
                                          item.currencyType === 'TZS',
                                      },
                                    ]"
                                    @click="
                                      item.currencyType = 'TZS'
                                      isEdit = true
                                    ">
                                    <span class="select-option__name">TZS</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="season-box__table__price">
                            <input
                              type="number"
                              placeholder="Price"
                              v-model="item.price"
                              @input="isEdit = true"
                              @focus="
                                $event.target.parentElement.classList.remove(
                                  'is-error'
                                )
                              "
                              class="form-control form-control-other-price" />
                          </div>
                          <div class="season-box__table__check">
                            <div
                              class="form-control-group"
                              @click="
                                item.perSafariDay = !item.perSafariDay
                                isEdit = true
                              ">
                              <label
                                class="form-control-checkbox"
                                @click.prevent>
                                <input
                                  type="checkbox"
                                  :checked="item.perSafariDay" /><span
                                  class="form-control-checkbox__box">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-check">
                                    <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                                ><span class="form-control-checkbox__name"
                                  >Per safari day</span
                                >
                              </label>
                            </div>
                          </div>
                          <div class="season-box__table__check">
                            <div
                              class="form-control-group"
                              @click="
                                item.perPerson = !item.perPerson
                                isEdit = true
                              ">
                              <label
                                class="form-control-checkbox"
                                @click.prevent>
                                <input
                                  type="checkbox"
                                  :checked="item.perPerson" /><span
                                  class="form-control-checkbox__box">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-check">
                                    <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                                ><span class="form-control-checkbox__name"
                                  >Per person</span
                                >
                              </label>
                            </div>
                          </div>
                          <div class="season-box__table__check">
                            <div
                              class="form-control-group"
                              @click="
                                item.perCar = !item.perCar
                                isEdit = true
                              ">
                              <label
                                class="form-control-checkbox"
                                @click.prevent>
                                <input
                                  type="checkbox"
                                  :checked="item.perCar" /><span
                                  class="form-control-checkbox__box">
                                  <svg
                                    width="1em"
                                    height="1em"
                                    class="icon icon-check">
                                    <use
                                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                                ><span class="form-control-checkbox__name"
                                  >Per car</span
                                >
                              </label>
                            </div>
                          </div>
                          <div class="season-box__table__action">
                            <button
                              type="button"
                              class="btn btn--remove"
                              @click="
                                $emit('deleteModalHandler', {
                                  entity: 'Setting',
                                  name: 'this',
                                  handler: deleteOther,
                                  id: index,
                                })
                              ">
                              <svg
                                width="1em"
                                height="1em"
                                class="icon icon-close">
                                <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="calculation-settings__box__submit">
                      <button
                        type="button"
                        class="btn btn--rounded"
                        @click="addOther">
                        <span>Add</span>
                      </button>
                      <button
                        type="button"
                        class="btn btn--green btn--sm btn--save"
                        @click="saveOther">
                        <span>Save</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
        <div class="prices-wrap_safari" v-if="isLoad">
          <div class="container-lg">
            <h2>SAFARI COST</h2>
            <div class="prices-wrap" v-if="details.details">
              <div class="languages-group">
                <label
                  class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                  @click="activeDetail = 'EN'">
                  <input
                    type="radio"
                    name="lanuage"
                    :checked="activeDetail === 'EN'" />
                  <div class="np-detail-collapse__lang__icon">
                    <svg width="1em" height="1em" class="icon icon-gb">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                    </svg>
                  </div>
                  <span class="np-detail-collapse__lang__text">English</span>
                </label>
                <label
                  class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                  @click="activeDetail = 'RU'">
                  <input
                    type="radio"
                    name="lanuage"
                    :checked="activeDetail === 'RU'" />
                  <div class="np-detail-collapse__lang__icon">
                    <svg width="1em" height="1em" class="icon icon-rus">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                    </svg>
                  </div>
                  <span class="np-detail-collapse__lang__text">Russian</span>
                </label>
                <label
                  class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                  @click="activeDetail = 'DE'">
                  <input
                    type="radio"
                    name="lanuage"
                    :checked="activeDetail === 'DE'" />
                  <div class="np-detail-collapse__lang__icon">
                    <svg width="1em" height="1em" class="icon icon-deu">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                    </svg>
                  </div>
                  <span class="np-detail-collapse__lang__text">Deutch</span>
                </label>
                <label
                  class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                  @click="activeDetail = 'ES'">
                  <input
                    type="radio"
                    name="lanuage"
                    :checked="activeDetail === 'ES'" />
                  <div class="np-detail-collapse__lang__icon">
                    <svg width="1em" height="1em" class="icon icon-deu">
                      <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-es"></use>
                    </svg>
                  </div>
                  <span class="np-detail-collapse__lang__text">Spanish</span>
                </label>
                <label
                    class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                    @click="activeDetail = 'FR'">
                  <input
                      type="radio"
                      name="lanuage"
                      :checked="activeDetail === 'FR'" />
                  <div class="np-detail-collapse__lang__icon">
                    <svg width="1em" height="1em" class="icon icon-fr">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fr"></use>
                    </svg>
                  </div>
                  <span class="np-detail-collapse__lang__text">French</span>
                </label>
                <label
                    class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                    @click="activeDetail = 'PT'">
                  <input
                      type="radio"
                      name="lanuage"
                      :checked="activeDetail === 'PT'" />
                  <div class="np-detail-collapse__lang__icon">
                    <svg width="1em" height="1em" class="icon icon-pt">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-pt"></use>
                    </svg>
                  </div>
                  <span class="np-detail-collapse__lang__text">Portuguese</span>
                </label>
                <label
                    class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                    @click="activeDetail = 'NL'">
                  <input
                      type="radio"
                      name="lanuage"
                      :checked="activeDetail === 'NL'" />
                  <div class="np-detail-collapse__lang__icon">
                    <svg width="1em" height="1em" class="icon icon-nl">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-nl"></use>
                    </svg>
                  </div>
                  <span class="np-detail-collapse__lang__text">Dutch</span>
                </label>
              </div>
              <div class="text-edit-price-wrapper">
                <div class="text-edit-price">
                  <div class="text-edit-price__item">
                    <div class="text-edit-price__head">
                      <span class="text-edit-price__head-icon">
                        <svg width="1em" height="1em" class="icon icon-check">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                        </svg>
                      </span>
                      INCLUDES
                    </div>
                    <div class="form-control-wrap">
                      <div class="text-heading">
                        Transfers
                      </div>
                      <div class="text-edit-price__text">
                        <div class="js-ckeditor">
                          <editor
                            @input="isEdit = true"
                            :editor="editor"
                            v-model="
                              details.details[activeDetail].inclusion.transfers
                            "
                            :config="editorConfig"></editor>
                        </div>
                      </div>
                      <div class="text-heading">
                        Accommodation & meals
                      </div>
                      <div class="text-edit-price__text">
                        <div class="js-ckeditor">
                          <editor
                            @input="isEdit = true"
                            :editor="editor"
                            v-model="
                              details.details[activeDetail].inclusion
                                .accommodations
                            "
                            :config="editorConfig"></editor>
                        </div>
                      </div>
                      <div class="text-heading">
                        Guiding & game-driving
                      </div>
                      <div class="text-edit-price__text">
                        <div class="js-ckeditor">
                          <editor
                            @input="isEdit = true"
                            :editor="editor"
                            v-model="
                              details.details[activeDetail].inclusion.guiding
                            "
                            :config="editorConfig"></editor>
                        </div>
                      </div>
                      <!-- <div class="text-heading">Meals:</div>
							<div class="text-edit-price__text">
								<div class="js-ckeditor">
									<editor @input="isEdit = true" :editor="editor" v-model="details.details[activeDetail].inclusion.meals" :config="editorConfig"></editor>
								</div>
                            </div>
							<div class="text-heading">Hiking and safety equipment:</div>
							<div class="text-edit-price__text">
								<div class="js-ckeditor">
									<editor @input="isEdit = true" :editor="editor" v-model="details.details[activeDetail].inclusion.hiking" :config="editorConfig"></editor>
								</div>
                            </div>
							<div class="text-heading">Climbing crew:</div>
							<div class="text-edit-price__text">
								<div class="js-ckeditor">
									<editor @input="isEdit = true" :editor="editor" v-model="details.details[activeDetail].inclusion.climbingCrew" :config="editorConfig"></editor>
								</div>
                            </div> -->
                    </div>
                  </div>
                  <div class="text-edit-price__item">
                    <div class="text-edit-price__head">
                      <span class="text-edit-price__head-icon">
                        <svg width="1em" height="1em" class="icon icon-close">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                        </svg>
                      </span>
                      EXCLUDES
                    </div>
                    <div class="form-control-wrap">
                      <div class="js-ckeditor">
                        <editor
                          @input="isEdit = true"
                          :editor="editor"
                          v-model="details.details[activeDetail].exclusion"
                          :config="editorConfig2"></editor>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-save-btn">
                <button
                  type="button"
                  class="btn btn--green"
                  @click="updateSafariDetailsHandler()">
                  <span>Save</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <Seasons
      @notLeavePopupHandler="(data) => $emit('notLeavePopupHandler', data)"
      @errored="$emit('errored')"
      @deleteModalHandler="(data) => $emit('deleteModalHandler', data)"
      :open="isOpenSeasonsCar"
      @confirmed="$emit('confirmed')"
      :title="'Car - Rental'"
      @close="closeSeasonsCar"
      :type="'car'"
      :user="user" />
    <Seasons
      @notLeavePopupHandler="(data) => $emit('notLeavePopupHandler', data)"
      @errored="$emit('errored')"
      @deleteModalHandler="(data) => $emit('deleteModalHandler', data)"
      :open="isOpenSeasonsOther"
      @confirmed="$emit('confirmed')"
      :title="'Other Expenses'"
      @close="closeSeasonsOther"
      :type="'other'"
      :user="user" />
    <div class="modal-wrapper" v-if="copyCar">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-season">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-copy">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                </svg>
              </div>
              <span>Copy rates </span>
            </div>
            <div class="edit-popup__close" @click="copyCar = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__info">
              <p>
                {{ carSeasons.find((item) => item.active).name }}
                <i
                  >{{ carSeasons.find((item) => item.active).dateFrom }} -
                  {{ carSeasons.find((item) => item.active).dateTo }}</i
                >
              </p>
            </div>
            <div class="edit-popup__side-wrap">
              <div class="edit-popup__side">
                <div class="form-control-group">
                  <span class="form-control-label form-control-label-bold"
                    >Prices for the
                    <b>"{{ carSeasons.find((item) => item.active).name }}"</b>
                    season will be copied from the season:</span
                  >
                  <div
                    :class="[
                      'select-wrapper',
                      'select-wrapper--xl',
                      {'is-active': selects.carCopy},
                    ]"
                    @click="changeSelects('carCopy')">
                    <div class="select-trigger">
                      <span class="select-trigger__name"
                        ><b>{{
                          carSeasonsCopy.find((item) => item.active).name
                        }}</b>
                        <i
                          >{{
                            carSeasonsCopy.find((item) => item.active).dateFrom
                          }}
                          -
                          {{
                            carSeasonsCopy.find((item) => item.active).dateTo
                          }}</i
                        ></span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div
                          v-for="item in carSeasonsCopy"
                          :key="item.id"
                          :class="[
                            'select-option',
                            {
                              'is-selected':
                                item.id ===
                                carSeasonsCopy.find((item) => item.active).id,
                            },
                          ]"
                          @click="
                            carSeasonsCopy = carSeasonsCopy.map((season) =>
                              item.id === season.id
                                ? {...season, active: true}
                                : {...season, active: false}
                            )
                          ">
                          <span class="select-option__name"
                            ><b>{{ item.name }}</b>
                            <i>{{ item.dateFrom }} - {{ item.dateTo }}</i></span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                class="btn btn--green edit-popup__submit"
                @click.prevent="copySeasons('car')">
                <svg width="1em" height="1em" class="icon icon-copy">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use></svg
                ><span>Copy</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="copyOther">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-season">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-copy">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                </svg>
              </div>
              <span>Copy rates</span>
            </div>
            <div class="edit-popup__close" @click="copyOther = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="edit-popup__info">
              <p>
                {{ otherSeasons.find((item) => item.active).name }}
                <i
                  >{{ otherSeasons.find((item) => item.active).dateFrom }} -
                  {{ otherSeasons.find((item) => item.active).dateTo }}</i
                >
              </p>
            </div>
            <div class="edit-popup__side-wrap">
              <div class="edit-popup__side">
                <div class="form-control-group">
                  <span class="form-control-label form-control-label-bold"
                    >Prices for the
                    <b>"{{ otherSeasons.find((item) => item.active).name }}"</b>
                    season will be copied from the season:</span
                  >
                  <div
                    :class="[
                      'select-wrapper',
                      'select-wrapper--xl',
                      {'is-active': selects.otherCopy},
                    ]"
                    @click="changeSelects('otherCopy')">
                    <div class="select-trigger">
                      <span class="select-trigger__name"
                        ><b>{{
                          otherSeasonsCopy.find((item) => item.active).name
                        }}</b>
                        <i
                          >{{
                            otherSeasonsCopy.find((item) => item.active)
                              .dateFrom
                          }}
                          -
                          {{
                            otherSeasonsCopy.find((item) => item.active).dateTo
                          }}</i
                        ></span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner">
                        <div
                          v-for="item in otherSeasonsCopy"
                          :key="item.id"
                          :class="[
                            'select-option',
                            {
                              'is-selected':
                                item.id ===
                                otherSeasonsCopy.find((item) => item.active).id,
                            },
                          ]"
                          @click="
                            otherSeasonsCopy = otherSeasonsCopy.map((season) =>
                              item.id === season.id
                                ? {...season, active: true}
                                : {...season, active: false}
                            )
                          ">
                          <span class="select-option__name"
                            ><b>{{ item.name }}</b>
                            <i>{{ item.dateFrom }} - {{ item.dateTo }}</i></span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                class="btn btn--green edit-popup__submit"
                @click.prevent="copySeasons('other')">
                <svg width="1em" height="1em" class="icon icon-copy">
                  <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use></svg
                ><span>Copy</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {date} from '@/utilites/functions'

import {
  getSeasonsType,
  getCarsSeasons,
  getExpensesSeasons,
  copyCarsSeasons,
  copyExpensesSeasons,
  saveExpensesSeasons,
  saveCarSeasons,
  updateSafariDetails,
  getSafariDetails,
} from '@/utilites/api'

import Seasons from '@/components/Seasons'
import ClipboardJS from 'clipboard'

import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        placeholder: 'Description',
      },
      editorConfig2: {
        placeholder: 'Exclusions',
      },
      details: {
        details: {
          EN: {
            inclusion: {
              transfers: '',
              guiding: '',
              accommodations: '',
            },
            exclusion: '',
          },
          RU: {
            inclusion: {
              transfers: '',
              guiding: '',
              accommodations: '',
            },
            exclusion: '',
          },
          DE: {
            inclusion: {
              transfers: '',
              guiding: '',
              accommodations: '',
            },
            exclusion: '',
          },
          ES: {
            inclusion: {
              transfers: '',
              guiding: '',
              accommodations: '',
            },
            exclusion: '',
          },
          FR: {
            inclusion: {
              transfers: '',
              guiding: '',
              accommodations: '',
            },
            exclusion: '',
          },
          PT: {
            inclusion: {
              transfers: '',
              guiding: '',
              accommodations: '',
            },
            exclusion: '',
          },
          NL: {
            inclusion: {
              transfers: '',
              guiding: '',
              accommodations: '',
            },
            exclusion: '',
          },
        },
      },
      activeDetail: 'EN',
      carSeasons: [],
      carSeasonsCopy: [],
      otherSeasons: [],
      otherSeasonsCopy: [],
      carsData: [],
      otherData: [],
      selects: {
        car: false,
        other: false,
        carCopy: false,
        otherCopy: false,
      },
      isOpenSeasonsCar: false,
      isOpenSeasonsOther: false,
      copyCar: false,
      copyOther: false,
      isLoad: false,
      isEdit: false,
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  components: {Seasons, ClipboardJS, editor: CKEditor.component},
  props: ['user'],
  beforeCreate() {
    document.title = 'Safari / Calculation Setting'
  },
  mounted() {
    document.title = 'Safari / Calculation Setting'
    Promise.allSettled([
      getSeasonsType(this.user.access_token, 'car'),
      getSeasonsType(this.user.access_token, 'other'),
      getSafariDetails(),
    ]).then((res) => {
      console.log(res)
      this.isLoad = true
      this.carSeasons =
        res[0].status === 'fulfilled'
          ? res[0].value.map((item, index) =>
              index === 0 ? {...item, active: true} : {...item, active: false}
            )
          : []
      this.carSeasons.sort((a, b) =>
        a.dateFrom.slice(-4) > b.dateFrom.slice(-4) ? 1 : -1
      )
      this.carSeasonsCopy =
        res[0].status === 'fulfilled'
          ? res[0].value.map((item, index) =>
              index === 0 ? {...item, active: true} : {...item, active: false}
            )
          : []
      this.carSeasonsCopy.sort((a, b) =>
        a.dateFrom.slice(-4) > b.dateFrom.slice(-4) ? 1 : -1
      )
      this.otherSeasons =
        res[1].status === 'fulfilled'
          ? res[1].value.map((item, index) =>
              index === 0 ? {...item, active: true} : {...item, active: false}
            )
          : []
      this.otherSeasons.sort((a, b) =>
        a.dateFrom.slice(-4) > b.dateFrom.slice(-4) ? 1 : -1
      )
      this.otherSeasonsCopy =
        res[1].status === 'fulfilled'
          ? res[1].value.map((item, index) =>
              index === 0 ? {...item, active: true} : {...item, active: false}
            )
          : []
      this.otherSeasonsCopy.sort((a, b) =>
        a.dateFrom.slice(-4) > b.dateFrom.slice(-4) ? 1 : -1
      )
      this.details = res[2].status === 'fulfilled' ? { details: {...this.details.details, ...res[2].value.details}} : this.details
    })
    window.addEventListener('click', (event) => {
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
          car: false,
          other: false,
          carCopy: false,
          otherCopy: false,
        }
        this.carsData = this.carsData.map((item) => ({...item, select: false}))
        this.otherData = this.otherData.map((item) => ({
          ...item,
          select: false,
        }))
      }
      if (
        !event.target.closest('.edit-popup') &&
        !event.target.closest('.btn')
      ) {
        this.copyOther = false
        this.copyCar = false
      }
    })
    let clip = new ClipboardJS('.copylink-btn')
    clip.on('success', () => {
      this.copyCar = false
    })
    let clip2 = new ClipboardJS('.copylink-btn2')
    clip2.on('success', () => {
      this.copyOther = false
    })
  },
  watch: {
    carSeasons() {
      let season = this.carSeasons.find((item) => item.active)
      if (season) {
        this.isLoad = false
        getCarsSeasons(this.user.access_token, season.id).then((res) => {
          this.isLoad = true
          this.carsData = res
            .map((item) => ({...item, select: false}))
            .sort((a, b) => a.name - b.name)
        })
      }
    },
    otherSeasons() {
      let season = this.otherSeasons.find((item) => item.active)
      if (season) {
        this.isLoad = false
        getExpensesSeasons(this.user.access_token, season.id).then((res) => {
          this.isLoad = true
          this.otherData = res.map((item) => ({...item, select: false}))
        })
      }
    },
    isOpenSeasonsCar() {
      if (!this.isOpenSeasonsCar) {
        getSeasonsType(this.user.access_token, 'car').then((res) => {
          this.carSeasons = res.map((item, index) =>
            index === 0 ? {...item, active: true} : {...item, active: false}
          )
          this.carSeasonsCopy = res.map((item, index) =>
            index === 0 ? {...item, active: true} : {...item, active: false}
          )
        })
      }
    },
    isOpenSeasonsOther() {
      if (!this.isOpenSeasonsOther) {
        getSeasonsType(this.user.access_token, 'other').then((res) => {
          this.otherSeasons = res.map((item, index) =>
            index === 0 ? {...item, active: true} : {...item, active: false}
          )
          this.otherSeasonsCopy = res.map((item, index) =>
            index === 0 ? {...item, active: true} : {...item, active: false}
          )
        })
      }
    },
  },
  methods: {
    updateSafariDetailsHandler() {
      updateSafariDetails({details: this.details.details}).then(() => {
        this.$emit('confirmed')
        this.isEdit = false
      })
    },
    changeSelects(target) {
      this.selects = {
        car: false,
        other: false,
        carCopy: false,
        otherCopy: false,
        [target]: !this.selects[target],
      }
    },
    checkErrors() {
      let error = false
      document.querySelectorAll('.form-control-other-name').forEach((elem) => {
        if (elem.value.length === 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      document.querySelectorAll('.form-control-other-price').forEach((elem) => {
        if (elem.value.length === 0 || elem.value <= 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      return error
    },
    checkErrorsRental() {
      let error = false
      document.querySelectorAll('.form-control-calc-name').forEach((elem) => {
        if (elem.value.length === 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      document.querySelectorAll('.form-control-calc-price').forEach((elem) => {
        if (elem.value.length === 0 || elem.value <= 0) {
          elem.parentElement.classList.add('is-error')
          error = true
        }
      })
      return error
    },
    addOther() {
      this.otherData = this.otherData.concat({
        currencyType: 'USD',
        id: this.otherData.length + 1,
        name: '',
        perPerson: false,
        perSafariDay: false,
        perCar: false,
        price: '',
        seasonId: this.otherSeasons.find((item) => item.active).id,
        added: true,
      })
      this.isEdit = true
    },
    deleteOther(id) {
      this.otherData = this.otherData.filter((_, index) => !(index === id))
      this.isEdit = true
    },
    saveOther() {
      if (!this.checkErrors()) {
        saveExpensesSeasons(
          this.user.access_token,
          this.otherSeasons.find((item) => item.active).id,
          this.otherData
        )
          .then((res) => {
            this.$emit('confirmed')
            this.isEdit = false
          })
          .catch((error) => {
            // this.errored()
          })
      }
    },
    saveRental() {
      if (!this.checkErrorsRental()) {
        saveCarSeasons(
          this.user.access_token,
          this.carSeasons.find((item) => item.active).id,
          this.carsData
        )
          .then((res) => {
            this.$emit('confirmed')
            this.isEdit = false
          })
          .catch((error) => {
            // this.errored()
          })
      }
    },
    addRental() {
      this.carsData = this.carsData.concat({
        currencyType: 'USD',
        name: '',
        price: '',
        seasonId: this.carSeasons.find((item) => item.active).id,
        added: true,
        select: false,
      })
      this.isEdit = true
    },
    removeRental(id) {
      this.carsData = this.carsData.filter((_, index) => !(index === id))
      this.isEdit = true
    },
    closeSeasonsCar() {
      this.isOpenSeasonsCar = false
    },
    closeSeasonsOther() {
      this.isOpenSeasonsOther = false
    },
    copySeasons(type) {
      if (type === 'car') {
        copyCarsSeasons(
          this.user.access_token,
          this.carSeasonsCopy.find((item) => item.active).id,
          this.carSeasons.find((item) => item.active).id
        ).then((res) => {
          this.carsData = res
            .map((item) => ({...item, select: false}))
            .map((item) => {
              delete item.id
              return item
            })
          this.copyCar = false
        })
      } else {
        copyExpensesSeasons(
          this.user.access_token,
          this.otherSeasonsCopy.find((item) => item.active).id,
          this.otherSeasons.find((item) => item.active).id
        ).then((res) => {
          this.otherData = res
            .map((item) => ({...item, select: false}))
            .map((item) => {
              delete item.id
              return item
            })
          this.copyOther = false
        })
      }
    },
    dateConvert(dateVal) {
      return date(dateVal, 's')
    },
  },
}
</script>
